<div class="container pt-4">
    <div class="row">
        <div class="col-md-4" *ngFor="let organization of organizations">
            <div class="card mb-4">
                <ng-container *ngIf="organization.imagePath; else elseTemplate">
                    <div class="d-flex justify-content-center pt-1">
                        <img class="img-fluid" style="max-width: 50%; object-fit: contain;"
                            [src]="imagePath+organization.id+'/'+organization.imagePath" />
                    </div>
                </ng-container>
                <ng-template #elseTemplate>
                    <div class="d-flex justify-content-center">
                        <img class="img-fluid"
                            [src]="(organization.organizationTypeId == 1 ? 'assets/images/lidonews-placeholder.jpg' : 'assets/images/museumnews-placeholder.jpg')" />
                    </div>
                </ng-template>
                <div class="card-body">
                    <blockquote class="blockquote">
                        <p class="mb-0">{{organization['name_'+currentLanguage]}}</p>
                    </blockquote>
                    <div class="d-flex justify-content-between align-items-center btn-group-sm btn-group-vertical">
                        <a
                            [routerLink]="['user','counter', organization.id]" class="btn btn-sm btn-outline-secondary">
                            <fa-icon [icon]="icons['faUserPlus']"></fa-icon> {{'ORGANIZATION.counter' | translate}}
                        </a>
                        <!-- <button type="button" class="btn btn-sm btn-outline-secondary" disabled="disabled">
                            <fa-icon [icon]="icons['faSearchPlus']"></fa-icon>
                            Preview
                        </button> -->
                        <a [routerLink]="['organization', organization.id, 'informations']"
                            class="btn btn-sm btn-outline-secondary">
                            <fa-icon [icon]="icons['faEdit']"></fa-icon> {{'ORGANIZATION.edit' | translate}}
                        </a>
                        <!-- <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="onElementDelete(organization.id)">
                            <fa-icon [icon]="icons['faTrashAlt']"></fa-icon> {{'ORGANIZATION.delete' | translate}}
                        </button> -->
                    </div>
                </div>
                <div class="card-footer" style="text-align: center;">
                  <ng-container *ngIf="organization['favorites'] > 0">
                    <fa-icon [icon]="icons['faHeart']" class="fa-1x" style="color:red"></fa-icon>&nbsp;<b>{{organization['favorites']}}</b>
                  </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirm-modal #confirmModal></app-confirm-modal>
